
import { PropType, computed, defineComponent } from 'vue';

import { BannerType, bannerTypes } from './useBanner';

const iconTypeMapping = {
  error: 'app:system',
  info: 'app:system',
  success: 'app:system',
  warning: 'app:system',
};

export default defineComponent({
  name: 'SBanner',
  props: {
    type: {
      required: false,
      type: String as PropType<BannerType>,
      default: 'info',
      validator: (v: BannerType) => bannerTypes.includes(v),
    },
    withIcon: {
      required: false,
      type: Boolean,
      default: true,
    },
    closable: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const iconByType = computed(() => iconTypeMapping[props.type]);

    const close = (): void => {
      emit('close');
    };

    return {
      close,
      iconByType,
    };
  },
});
